import { useState, useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import MediaSection from './components/MediaSection';
import CatalogSection from './components/CatalogSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-linear-to-br from-teal-400 via-teal-500 to-teal-600 font-['Inter']">
      <Header isScrolled={isScrolled} />
      <HeroSection />
      <ServicesSection />
      <CatalogSection />
      <MediaSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
